// Généré depuis Intl.DisplayNames — noms et slugs des 27 pays UE dans les 6 langues de l'app.
export const LABEL_COUNTRIES = {
  "fr": {
    "FR": {
      "name": "France",
      "slug": "france"
    },
    "DE": {
      "name": "Allemagne",
      "slug": "allemagne"
    },
    "AT": {
      "name": "Autriche",
      "slug": "autriche"
    },
    "BE": {
      "name": "Belgique",
      "slug": "belgique"
    },
    "BG": {
      "name": "Bulgarie",
      "slug": "bulgarie"
    },
    "CY": {
      "name": "Chypre",
      "slug": "chypre"
    },
    "HR": {
      "name": "Croatie",
      "slug": "croatie"
    },
    "DK": {
      "name": "Danemark",
      "slug": "danemark"
    },
    "ES": {
      "name": "Espagne",
      "slug": "espagne"
    },
    "EE": {
      "name": "Estonie",
      "slug": "estonie"
    },
    "FI": {
      "name": "Finlande",
      "slug": "finlande"
    },
    "GR": {
      "name": "Grèce",
      "slug": "grece"
    },
    "HU": {
      "name": "Hongrie",
      "slug": "hongrie"
    },
    "IE": {
      "name": "Irlande",
      "slug": "irlande"
    },
    "IT": {
      "name": "Italie",
      "slug": "italie"
    },
    "LV": {
      "name": "Lettonie",
      "slug": "lettonie"
    },
    "LT": {
      "name": "Lituanie",
      "slug": "lituanie"
    },
    "LU": {
      "name": "Luxembourg",
      "slug": "luxembourg"
    },
    "MT": {
      "name": "Malte",
      "slug": "malte"
    },
    "NL": {
      "name": "Pays-Bas",
      "slug": "pays-bas"
    },
    "PL": {
      "name": "Pologne",
      "slug": "pologne"
    },
    "PT": {
      "name": "Portugal",
      "slug": "portugal"
    },
    "RO": {
      "name": "Roumanie",
      "slug": "roumanie"
    },
    "SK": {
      "name": "Slovaquie",
      "slug": "slovaquie"
    },
    "SI": {
      "name": "Slovénie",
      "slug": "slovenie"
    },
    "SE": {
      "name": "Suède",
      "slug": "suede"
    },
    "CZ": {
      "name": "Tchéquie",
      "slug": "tchequie"
    }
  },
  "en": {
    "FR": {
      "name": "France",
      "slug": "france"
    },
    "DE": {
      "name": "Germany",
      "slug": "germany"
    },
    "AT": {
      "name": "Austria",
      "slug": "austria"
    },
    "BE": {
      "name": "Belgium",
      "slug": "belgium"
    },
    "BG": {
      "name": "Bulgaria",
      "slug": "bulgaria"
    },
    "CY": {
      "name": "Cyprus",
      "slug": "cyprus"
    },
    "HR": {
      "name": "Croatia",
      "slug": "croatia"
    },
    "DK": {
      "name": "Denmark",
      "slug": "denmark"
    },
    "ES": {
      "name": "Spain",
      "slug": "spain"
    },
    "EE": {
      "name": "Estonia",
      "slug": "estonia"
    },
    "FI": {
      "name": "Finland",
      "slug": "finland"
    },
    "GR": {
      "name": "Greece",
      "slug": "greece"
    },
    "HU": {
      "name": "Hungary",
      "slug": "hungary"
    },
    "IE": {
      "name": "Ireland",
      "slug": "ireland"
    },
    "IT": {
      "name": "Italy",
      "slug": "italy"
    },
    "LV": {
      "name": "Latvia",
      "slug": "latvia"
    },
    "LT": {
      "name": "Lithuania",
      "slug": "lithuania"
    },
    "LU": {
      "name": "Luxembourg",
      "slug": "luxembourg"
    },
    "MT": {
      "name": "Malta",
      "slug": "malta"
    },
    "NL": {
      "name": "Netherlands",
      "slug": "netherlands"
    },
    "PL": {
      "name": "Poland",
      "slug": "poland"
    },
    "PT": {
      "name": "Portugal",
      "slug": "portugal"
    },
    "RO": {
      "name": "Romania",
      "slug": "romania"
    },
    "SK": {
      "name": "Slovakia",
      "slug": "slovakia"
    },
    "SI": {
      "name": "Slovenia",
      "slug": "slovenia"
    },
    "SE": {
      "name": "Sweden",
      "slug": "sweden"
    },
    "CZ": {
      "name": "Czechia",
      "slug": "czechia"
    }
  },
  "de": {
    "FR": {
      "name": "Frankreich",
      "slug": "frankreich"
    },
    "DE": {
      "name": "Deutschland",
      "slug": "deutschland"
    },
    "AT": {
      "name": "Österreich",
      "slug": "osterreich"
    },
    "BE": {
      "name": "Belgien",
      "slug": "belgien"
    },
    "BG": {
      "name": "Bulgarien",
      "slug": "bulgarien"
    },
    "CY": {
      "name": "Zypern",
      "slug": "zypern"
    },
    "HR": {
      "name": "Kroatien",
      "slug": "kroatien"
    },
    "DK": {
      "name": "Dänemark",
      "slug": "danemark"
    },
    "ES": {
      "name": "Spanien",
      "slug": "spanien"
    },
    "EE": {
      "name": "Estland",
      "slug": "estland"
    },
    "FI": {
      "name": "Finnland",
      "slug": "finnland"
    },
    "GR": {
      "name": "Griechenland",
      "slug": "griechenland"
    },
    "HU": {
      "name": "Ungarn",
      "slug": "ungarn"
    },
    "IE": {
      "name": "Irland",
      "slug": "irland"
    },
    "IT": {
      "name": "Italien",
      "slug": "italien"
    },
    "LV": {
      "name": "Lettland",
      "slug": "lettland"
    },
    "LT": {
      "name": "Litauen",
      "slug": "litauen"
    },
    "LU": {
      "name": "Luxemburg",
      "slug": "luxemburg"
    },
    "MT": {
      "name": "Malta",
      "slug": "malta"
    },
    "NL": {
      "name": "Niederlande",
      "slug": "niederlande"
    },
    "PL": {
      "name": "Polen",
      "slug": "polen"
    },
    "PT": {
      "name": "Portugal",
      "slug": "portugal"
    },
    "RO": {
      "name": "Rumänien",
      "slug": "rumanien"
    },
    "SK": {
      "name": "Slowakei",
      "slug": "slowakei"
    },
    "SI": {
      "name": "Slowenien",
      "slug": "slowenien"
    },
    "SE": {
      "name": "Schweden",
      "slug": "schweden"
    },
    "CZ": {
      "name": "Tschechien",
      "slug": "tschechien"
    }
  },
  "es": {
    "FR": {
      "name": "Francia",
      "slug": "francia"
    },
    "DE": {
      "name": "Alemania",
      "slug": "alemania"
    },
    "AT": {
      "name": "Austria",
      "slug": "austria"
    },
    "BE": {
      "name": "Bélgica",
      "slug": "belgica"
    },
    "BG": {
      "name": "Bulgaria",
      "slug": "bulgaria"
    },
    "CY": {
      "name": "Chipre",
      "slug": "chipre"
    },
    "HR": {
      "name": "Croacia",
      "slug": "croacia"
    },
    "DK": {
      "name": "Dinamarca",
      "slug": "dinamarca"
    },
    "ES": {
      "name": "España",
      "slug": "espana"
    },
    "EE": {
      "name": "Estonia",
      "slug": "estonia"
    },
    "FI": {
      "name": "Finlandia",
      "slug": "finlandia"
    },
    "GR": {
      "name": "Grecia",
      "slug": "grecia"
    },
    "HU": {
      "name": "Hungría",
      "slug": "hungria"
    },
    "IE": {
      "name": "Irlanda",
      "slug": "irlanda"
    },
    "IT": {
      "name": "Italia",
      "slug": "italia"
    },
    "LV": {
      "name": "Letonia",
      "slug": "letonia"
    },
    "LT": {
      "name": "Lituania",
      "slug": "lituania"
    },
    "LU": {
      "name": "Luxemburgo",
      "slug": "luxemburgo"
    },
    "MT": {
      "name": "Malta",
      "slug": "malta"
    },
    "NL": {
      "name": "Países Bajos",
      "slug": "paises-bajos"
    },
    "PL": {
      "name": "Polonia",
      "slug": "polonia"
    },
    "PT": {
      "name": "Portugal",
      "slug": "portugal"
    },
    "RO": {
      "name": "Rumanía",
      "slug": "rumania"
    },
    "SK": {
      "name": "Eslovaquia",
      "slug": "eslovaquia"
    },
    "SI": {
      "name": "Eslovenia",
      "slug": "eslovenia"
    },
    "SE": {
      "name": "Suecia",
      "slug": "suecia"
    },
    "CZ": {
      "name": "Chequia",
      "slug": "chequia"
    }
  },
  "it": {
    "FR": {
      "name": "Francia",
      "slug": "francia"
    },
    "DE": {
      "name": "Germania",
      "slug": "germania"
    },
    "AT": {
      "name": "Austria",
      "slug": "austria"
    },
    "BE": {
      "name": "Belgio",
      "slug": "belgio"
    },
    "BG": {
      "name": "Bulgaria",
      "slug": "bulgaria"
    },
    "CY": {
      "name": "Cipro",
      "slug": "cipro"
    },
    "HR": {
      "name": "Croazia",
      "slug": "croazia"
    },
    "DK": {
      "name": "Danimarca",
      "slug": "danimarca"
    },
    "ES": {
      "name": "Spagna",
      "slug": "spagna"
    },
    "EE": {
      "name": "Estonia",
      "slug": "estonia"
    },
    "FI": {
      "name": "Finlandia",
      "slug": "finlandia"
    },
    "GR": {
      "name": "Grecia",
      "slug": "grecia"
    },
    "HU": {
      "name": "Ungheria",
      "slug": "ungheria"
    },
    "IE": {
      "name": "Irlanda",
      "slug": "irlanda"
    },
    "IT": {
      "name": "Italia",
      "slug": "italia"
    },
    "LV": {
      "name": "Lettonia",
      "slug": "lettonia"
    },
    "LT": {
      "name": "Lituania",
      "slug": "lituania"
    },
    "LU": {
      "name": "Lussemburgo",
      "slug": "lussemburgo"
    },
    "MT": {
      "name": "Malta",
      "slug": "malta"
    },
    "NL": {
      "name": "Paesi Bassi",
      "slug": "paesi-bassi"
    },
    "PL": {
      "name": "Polonia",
      "slug": "polonia"
    },
    "PT": {
      "name": "Portogallo",
      "slug": "portogallo"
    },
    "RO": {
      "name": "Romania",
      "slug": "romania"
    },
    "SK": {
      "name": "Slovacchia",
      "slug": "slovacchia"
    },
    "SI": {
      "name": "Slovenia",
      "slug": "slovenia"
    },
    "SE": {
      "name": "Svezia",
      "slug": "svezia"
    },
    "CZ": {
      "name": "Cechia",
      "slug": "cechia"
    }
  },
  "nl": {
    "FR": {
      "name": "Frankrijk",
      "slug": "frankrijk"
    },
    "DE": {
      "name": "Duitsland",
      "slug": "duitsland"
    },
    "AT": {
      "name": "Oostenrijk",
      "slug": "oostenrijk"
    },
    "BE": {
      "name": "België",
      "slug": "belgie"
    },
    "BG": {
      "name": "Bulgarije",
      "slug": "bulgarije"
    },
    "CY": {
      "name": "Cyprus",
      "slug": "cyprus"
    },
    "HR": {
      "name": "Kroatië",
      "slug": "kroatie"
    },
    "DK": {
      "name": "Denemarken",
      "slug": "denemarken"
    },
    "ES": {
      "name": "Spanje",
      "slug": "spanje"
    },
    "EE": {
      "name": "Estland",
      "slug": "estland"
    },
    "FI": {
      "name": "Finland",
      "slug": "finland"
    },
    "GR": {
      "name": "Griekenland",
      "slug": "griekenland"
    },
    "HU": {
      "name": "Hongarije",
      "slug": "hongarije"
    },
    "IE": {
      "name": "Ierland",
      "slug": "ierland"
    },
    "IT": {
      "name": "Italië",
      "slug": "italie"
    },
    "LV": {
      "name": "Letland",
      "slug": "letland"
    },
    "LT": {
      "name": "Litouwen",
      "slug": "litouwen"
    },
    "LU": {
      "name": "Luxemburg",
      "slug": "luxemburg"
    },
    "MT": {
      "name": "Malta",
      "slug": "malta"
    },
    "NL": {
      "name": "Nederland",
      "slug": "nederland"
    },
    "PL": {
      "name": "Polen",
      "slug": "polen"
    },
    "PT": {
      "name": "Portugal",
      "slug": "portugal"
    },
    "RO": {
      "name": "Roemenië",
      "slug": "roemenie"
    },
    "SK": {
      "name": "Slowakije",
      "slug": "slowakije"
    },
    "SI": {
      "name": "Slovenië",
      "slug": "slovenie"
    },
    "SE": {
      "name": "Zweden",
      "slug": "zweden"
    },
    "CZ": {
      "name": "Tsjechië",
      "slug": "tsjechie"
    }
  }
};

export const DIRECTORY_BASE = {
  fr: "/labels-environnementaux",
  en: "/environmental-labels",
  de: "/umweltlabels",
  es: "/etiquetas-ambientales",
  it: "/etichette-ambientali",
  nl: "/milieulabels",
};

export const COUNTRY_CODES = Object.keys(LABEL_COUNTRIES.fr);

export function countryBySlug(lang, slug) {
  const map = LABEL_COUNTRIES[lang] || LABEL_COUNTRIES.en;
  return COUNTRY_CODES.find((c) => map[c].slug === slug) || null;
}
